import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Farm } from '../models/farm.model';
import { Page } from '../models/page.model';

@Injectable({ providedIn: 'root' })
export class FarmService {
  private farmsUrl = '/farms';
  constructor(private http: HttpClient) {}

  getFarms(): Observable<Farm[]> {
    return this.http.get<any>(this.farmsUrl + '/all').pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  getFarm(id: number): Observable<Farm> {
    return this.http.get<any>(this.farmsUrl + '/' + id).pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  getFarmsAdvanced(
    pageIndex: number,
    itemsPerPage: number,
    sortColumnName: string,
    sortColumnOrder: string,
    filter: any,
    filterOrga: string,
    farmIds: number[],
    campaignId: number,
  ): Observable<Page<Farm>> {
    let url = this.farmsUrl + '?size=' + itemsPerPage + '&page=' + (pageIndex - 1);
    if (filter) {
      if (filter.filter) {
        url += '&prefix=' + filter.filter;
      }
      if (filter.filterAdvisor && filter.filterAdvisor != 'null') {
        url += '&advisor=' + filter.filterAdvisor;
      }
    }
    if (filterOrga) {
      url += '&orga=' + filterOrga;
    }
    if (sortColumnName) {
      url += '&sort=' + sortColumnName + ',' + sortColumnOrder;
    }
    if (farmIds) {
      url += '&farm=' + farmIds.join(',');
    }
    if (campaignId) {
      url += '&campaignId=' + campaignId;
    }
    return this.http.get<any>(url).pipe(
      map((response) => response.data),
      catchError(this.handleError),
    );
  }

  save(farm: Farm): Observable<Farm> {
    if (farm.id) {
      return this.put(farm);
    }
    return this.post(farm);
  }

  delete(farm: Farm) {
    const url = `${this.farmsUrl}/${farm.id}`;

    return this.http.delete(url).pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    // FIXME
    console.error('An error occurred', error);
    return throwError(() => error.message || error);
  }

  // Add new farm
  private post(farm: Farm): Observable<Farm> {
    return this.http.post<any>(this.farmsUrl, farm).pipe(
      map((res) => res.data),
      catchError(this.handleError),
    );
  }

  // Update existing farm
  private put(farm: Farm) {
    const url = `${this.farmsUrl}/${farm.id}`;

    return this.http.put<any>(url, farm).pipe(
      map((res) => res.data),
      catchError(this.handleError),
    );
  }
}
